import { api, clearTokens, isAuthenticated, setTokens } from "../client"
import { API_ENDPOINTS } from "../config"

export interface LoginRequest {
  email: string
  password: string
  rememberMe?: boolean
}

export interface LoginResponse {
  user: {
    id: string
    email: string
    firstName: string
    lastName: string
    role: string
  }
  token?: string
  accessToken?: string
  refreshToken: string
  expiresIn: number
}

export const authService = {
  async login(credentials: LoginRequest) {
    const response = await api.post<LoginResponse>(
      API_ENDPOINTS.AUTH.LOGIN,
      credentials
    )
    return { data: response.data, success: true }
  },

  logout() {
    clearTokens()
  },

  setTokens,
  clearTokens,
  isAuthenticated
}
